import React from "react";
import { Button } from "@agria/theme/src/components/button";
import { siteLinks } from "@agria/theme/src/const/siteLinks";
import { useMyAccount } from "@agria/theme-my-account/src/context/MyAccountContext";

export const VetClaim = () => {
  const { affiliate } = useMyAccount();
  return (
    <Button
      variant="primary"
      arrowRight
      url={`${siteLinks.onlineVetCLaims}?id=${affiliate?.Id}`}
      target="_blank"
    >
      Make a claim
    </Button>
  );
};
